export const Validate = (regex: RegExp, value: string) => {
  // NOTE : THE PAGE BECOME UNRESPONSIVE WHEN VALIDATING A STRING WITH A LENGTH GREATER THAN 200 IS BEING INPUT EVEN AFTER USING THE ONBLUR EVENT
  //  PLEASE ADJUST THE DESIRED LENGTH FOR THE LIMIT BASED ON YOUR ACTUAL VALIDATION
  if (value.length > 100) return false;
  if (regex.test(value)) return true;
  return false;
};
